!function(window) {
function treeMapEcharts(options) {
	// bind filter events 
	var $filterWrapper = $('.iopr-data-wrapper .filter-wrapper.tree-map').on('submit', 'form', function (ev) {
		ev.preventDefault();
		var $form = $(this);
		$form.find('button[type="submit"]').prop('disabled', true);
		fetchData($form);
	});

	// because filter option is disabled by default
	// we need to check dropdown change event and enable it if needed
	$filterWrapper.find('.iopr-select').each(function (i, item) {
		var $select = $(item);
		$select.on('changed.bs.select', function (e) {
			var val = e.currentTarget.value;
			var $formSubmit = $select.closest('form').find('button[type="submit"]');
			if (!val) {
				$formSubmit.prop('disabled', true);
			} else {
				$formSubmit.removeAttr('disabled');
			}
		});
	});

	// handles filter submit
	function fetchData($form) {
		//show loader
		// hide previous data
		if (!options.html.tree.chartData.hasClass('not-shown')) {
			options.html.tree.chartData.fadeOut(function () {
				options.html.tree.chartData.addClass('not-shown');
			})
		}
		// hide table
		if (!options.html.tree.tableWrapper.hasClass('not-shown')) {
			options.html.tree.tableWrapper.fadeOut(function () {
				options.html.tree.tableWrapper.addClass('not-shown');
				options.html.tree.tableWrapper.html('');
			})
		}


		// show loader
		if (options.html.tree.chartLoader.hasClass('not-shown')) {
			options.html.tree.chartLoader.fadeIn(function () {
				options.html.tree.chartLoader.removeClass('not-shown');

				var ajaxBody = setTreeMapAjaxBody($form);

				$.post(options.base.apiIncludeLng(), ajaxBody, function (data) {
		
					// DO STUFF WITH BODY CALL GOOGLE
					var dataJson = JSON.parse(data);
		
					// HIDE LOADER
					if (!options.html.tree.chartLoader.hasClass('not-shown')) {
						options.html.tree.chartLoader.fadeOut(function () {
							options.html.tree.chartLoader.addClass('not-shown');
		
							// SHOW DATA
							// table
							options.html.tree.tableWrapper.html(dataJson.table);
							options.html.tree.tableWrapper.fadeIn(function () {
								if (options.properties.useConfirm) {
									options.elements.tableModal = $('#tableRowAddRemoveModal');
								}
								options.html.tree.tableWrapper.removeClass('not-shown');
							})
		
							
							options.data.tree.baseData = dataJson.treemap;
							options.data.tree.currentData = dataJson.treemap.slice();
							generateChart();
							
							options.properties.setParent({}, 'echart');
							options.charts.stackedArea.validateFilter();
		
							// options.charts.tree.generate();
		
							options.html.tree.tableWrapper.fadeIn(function () {
								options.html.tree.tableWrapper.removeClass('not-shown');
							})
							options.html.tree.chartData.fadeIn(function () {
								options.html.tree.chartData.removeClass('not-shown');
							});
						});
					}
				});
		
			});
			
		}

		function setTreeMapAjaxBody($form) {
			// get year
			var obj = {};
			obj['cashFlow'] = options.properties.cashFlow;
			obj['type'] = options.properties.type;
			obj['dataType'] = 'tree-map';
			if (options.properties.type == 'month') {
				obj['period'] = $form.find('input[name="helper-period"]').val();
				obj['subPeriod'] = $form.find('#period-selector').val();
				
			} else if (options.properties.type == 'year-final') {
				obj['period'] = $form.find('#period-selector').val();
			}
			return obj;
		}
	}

	function generateChart(travel) {
		// use configuration
		if (!options.charts.tree.chart) {
			// based on prepared DOM, initialize echarts instance
			options.charts.tree.chart = echarts.init(options.html.tree.chartData[0]);
			options.charts.tree.chart.on('treemapRootToNode', (params, params1, params2) => {
				adjustStackedAreaChart(params);
			});
			options.charts.tree.chart.on('treemapZoomToNode', (params, params1, params2) => {
				adjustStackedAreaChart(params);
			});
			options.charts.tree.resize = () => options.charts.tree.chart.resize();
		}
		treeMapSetOptions()
		options.charts.tree.chart.setOption(options.charts.tree.options);
		if (travel) {
			const travel = options.properties.baseTravel;
			travel.targetNode = options.properties.targetNode;
			options.charts.tree.chart.dispatchAction(options.properties.baseTravel);
		}
	}

	function adjustStackedAreaChart(params) {
		options.properties.setParent(params.targetNode, 'echart', params);
		options.charts.stackedArea.travelLevels();
	}

	function treeMapSetOptions() {
		if (options.charts.tree.options) {
			options.charts.tree.options.series[0].data = options.data.tree.currentData;
		} else {
			const baseOptions = {
				series: [
					{
						type: 'treemap',
						label: {
							show: true,
							formatter: '{b}'
						},
						leafDepth: 1,
						upperLabel: {
							normal: {
								show: true,
								height: 30
							}
						},
						itemStyle: {
							normal: {
								borderColor: '#fff',
								borderWidth: 2
							}
						},
						roam: false,
						data: options.data.tree.currentData
					}
				]
			};
			options.charts.tree.options = baseOptions;
		}
		
	}

	options.charts.tree.generate = generateChart;
}

module.exports = treeMapEcharts;



window.treeMapEcharts = treeMapEcharts;
}.call(window, window);